import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../../services/static-data.service';
import {TreatmentService} from '../../../../services/treatment.service';
import {TreatmentEndoPerforationDataModel} from '../../models/treatment-endo-perforation-data.model';
import {MatRadioChange} from '@angular/material/radio';
import {ToothCanalConfigurationModel} from '../../../../models/configuration/tooth-canal-configuration.model';
import { Constants } from 'src/app/constants';
import { EditEnumDialogComponent } from 'src/app/dialog/edit-enum-dialog/edit-enum-dialog.component';
import { fromEvent, Subscription } from 'rxjs';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-treatment-perforation-dialog',
  templateUrl: './treatment-perforation-dialog.component.html',
  styleUrls: ['./treatment-perforation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreatmentPerforationDialogComponent implements OnInit {
  @ViewChild('enumOptionsMenu') enumOptionsMenu: TemplateRef<any>;
  toothNum: string = '';
  isLoading = true;
  tooth = 6;
  preopEnumId = '00000153-1000-0000-0000-000000000001';
  postOpEnumId = '00000153-1000-0000-0000-000000000002';
  opValue = '00000153-1000-0000-0000-000000000001';

  isRadiologicallyDiscernible = false;
  isClinicallyDiscernible = false;
  isSurgicallyAccessible = false;

  canalEnums: EnumValidValueItemModel[];
  canalsPerSelectedTooth: EnumValidValueItemModel[];

  crestalEnums: EnumValidValueItemModel[];
  sizeEnums: EnumValidValueItemModel[];
  typeEnums: EnumValidValueItemModel[];
  causedByEnums: EnumValidValueItemModel[];
  priorRepairEnums: EnumValidValueItemModel[];
  timeSincePerforationEnums: EnumValidValueItemModel[];
  repairMaterialEnums: EnumValidValueItemModel[];
  startupClassType: string;

  validValueItems: EnumValidValueItemModel[];
  isContextOpen: boolean = false;
  private overlayRef: OverlayRef | null;
  private sub: Subscription;

  //emptyGuid = '00000000-0000-0000-0000-000000000000';

  // treatmentModel: TreatmentEndoDataModel;
  // Used when one is passed in, like from diagnosis
  selectedPerforationModel: TreatmentEndoPerforationDataModel;
  // Otherwise expect a list so that one of each class type can exist
  perforationModels: TreatmentEndoPerforationDataModel[];
  allCanals: ToothCanalConfigurationModel[];
  treatmentId: string;

  constructor(private dialogRef: MatDialogRef<TreatmentPerforationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data,
              private treatmentService: TreatmentService,
              private statidDataService: StaticDataService,
              private dialog: MatDialog,
              private overlay: Overlay,
            private viewContainerRef: ViewContainerRef,
            private cdr: ChangeDetectorRef) {
    // this.treatmentModel = this.data.treatmentModel;
    this.startupClassType = data.classType;
    this.toothNum = data.toothNum;
    this.perforationModels = data.perforationModels;
    this.treatmentId = data.treatmentId;
  }

  ngOnInit(): void {
    this.canalEnums = this.statidDataService.getValidValueItemsByValidValueName('enumToothCanal');
    this.crestalEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfCrestal');
    this.sizeEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfSize');
    this.typeEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfType');
    this.causedByEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfCausedBy');
    this.priorRepairEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfPriorRepaire');
    this.timeSincePerforationEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfTimeSincePerf');
    this.repairMaterialEnums = this.statidDataService.getValidValueItemsByValidValueName('enumEndoPerfRepairMaterial');


    this.treatmentService.getCanalConfigurationModels().subscribe((canals) => {
      this.allCanals = canals;
      this.isLoading = false;
      this.cdr.markForCheck();
      if (!this.perforationModels) {
        this.perforationModels = [];
        if (this.treatmentId) {
          this.treatmentService.getTreatmentPerforations(this.treatmentId).subscribe((res) => {
            this.perforationModels = res;
            if (!this.selectedPerforationModel) {
              if (this.perforationModels) {
                this.selectedPerforationModel = this.perforationModels.find(p => p.enumEndoPerfClassTypeID.toLowerCase() === this.data.classType.toLowerCase());
              }
              if (!this.selectedPerforationModel) {
                this.selectedPerforationModel = new TreatmentEndoPerforationDataModel();
                this.selectedPerforationModel.enumEndoPerfClassTypeID = this.data.classType;
                this.selectedPerforationModel.TreatmentID = this.treatmentId;
                this.perforationModels.push(this.selectedPerforationModel);
              }
            }
            this.cdr.markForCheck();
          });
        } else {
          if (!this.selectedPerforationModel) {
            this.selectedPerforationModel = new TreatmentEndoPerforationDataModel();
            this.selectedPerforationModel.enumEndoPerfClassTypeID = this.data.classType;
            this.selectedPerforationModel.TreatmentID = this.treatmentId;
            this.perforationModels.push(this.selectedPerforationModel);
          }
        }
      } else {
        if (!this.selectedPerforationModel) {
          this.selectedPerforationModel = this.perforationModels.find(p => p.enumEndoPerfClassTypeID.toLowerCase() === this.data.classType.toLowerCase());
          if (!this.selectedPerforationModel) {
            this.selectedPerforationModel = new TreatmentEndoPerforationDataModel();
            this.selectedPerforationModel.enumEndoPerfClassTypeID = this.data.classType;
            this.selectedPerforationModel.TreatmentID = this.treatmentId;
            this.perforationModels.push(this.selectedPerforationModel);
          }
        }
      }
    });
  }

  saveTreatment() {
    this.treatmentService.saveTreatmentPerforation(this.selectedPerforationModel).subscribe((returnModel) => {
      const idx = this.perforationModels.findIndex(p => p.TretmentPerfID?.toLowerCase() === returnModel.TretmentPerfID.toLowerCase());
      if (idx > -1) {
        this.perforationModels[idx] = returnModel;
        this.selectedPerforationModel = returnModel;
      } else {
        this.perforationModels[0] = returnModel;
        this.selectedPerforationModel = returnModel;
      }
    });
  }

  isSelectedCrestalItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfCrestalID === ValidValueItemId;
  }

  onOkClick() {
    this.dialogRef.close(this.perforationModels);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onCanalClearClick() {
    this.selectedPerforationModel.enumToothCanalID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onCrestalClearClick() {
    this.selectedPerforationModel.enumEndoPerfCrestalID = Constants.emptyGuid;
    this.saveTreatment();
  }

  isSelectedSizeItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfSizeID === ValidValueItemId;
  }

  onSizeClearClick() {
    this.selectedPerforationModel.enumEndoPerfSizeID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onCrestalSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfCrestalID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  onSizeSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfSizeID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  onTypeClearClick() {
    this.selectedPerforationModel.enumEndoPerfTypeID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onTypeSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfTypeID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  isSelectedTypeItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfTypeID === ValidValueItemId;
  }

  onCausedByClearClick() {
    this.selectedPerforationModel.enumEndoPerfCausedByID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onCausedBySelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfCausedByID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  isSelectedCausedByItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfCausedByID === ValidValueItemId;
  }

  onPriorRepairClearClick() {
    this.selectedPerforationModel.enumEndoPerfPriorRepaireID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onPriorRepairSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfPriorRepaireID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  isSelectedPriorRepairItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfPriorRepaireID === ValidValueItemId;
  }

  onTimeSincePerforationClearClick() {
    this.selectedPerforationModel.enumEndoPerfTimeSincePerfID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onTimeSincePerforationSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfTimeSincePerfID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  isSelectedTimeSincePerforationItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfTimeSincePerfID === ValidValueItemId;
  }

  onRepairMaterialClearClick() {
    this.selectedPerforationModel.enumEndoPerfRepairMaterialID = Constants.emptyGuid;
    this.saveTreatment();
  }

  onRepairMaterialSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumEndoPerfRepairMaterialID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  isSelectedRepairMaterialItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumEndoPerfRepairMaterialID === ValidValueItemId;
  }

  onRadialChange($event: MatRadioChange, type: string, isYes: boolean) {
    switch (type) {
      case 'isPerfSurgicallyAccessible':
        this.selectedPerforationModel.isPerfSurgicallyAccessible = isYes;
        break;
      case 'isPerfClinicallyDiscern':
        this.selectedPerforationModel.isPerfClinicallyDiscern = isYes;
        break;
      case 'isPerfRadioDiscern':
        this.selectedPerforationModel.isPerfRadioDiscern = isYes;
        break;
    }

    this.saveTreatment();
  }

  onClassTypeRadialChange(opEnumId: string) {
    this.selectedPerforationModel.enumEndoPerfClassTypeID = opEnumId;
    this.saveTreatment();
  }

  clearAll() {
    this.selectedPerforationModel.enumToothCanalID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfCrestalID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfSizeID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfTypeID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfCausedByID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfPriorRepaireID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfTimeSincePerfID = Constants.emptyGuid;
    this.selectedPerforationModel.enumEndoPerfRepairMaterialID = Constants.emptyGuid;

    this.saveTreatment();
  }

  onCanalSelection(enumModel: EnumValidValueItemModel) {
    this.selectedPerforationModel.enumToothCanalID = enumModel.ValidValueItemId;
    this.saveTreatment();
  }

  isSelectedCanalItem(ValidValueItemId: string) {
    return this.selectedPerforationModel.enumToothCanalID === ValidValueItemId;
  }

  onEditList() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.validValueItems;
  
    this.dialog.open(EditEnumDialogComponent, config).afterClosed().subscribe((res) => {
        if (res) {
            this.validValueItems = [];
  
            setTimeout(() => {
                this.validValueItems = res;
            }, 100);
        }
    });
  }

  onRightMouseClick(event: MouseEvent, enumValue: any ) {
    if (enumValue === undefined || enumValue[0].enumValidValue.isSystem) {
       return;
     }
      if (enumValue === undefined ) {
       return;
     }
     event.preventDefault();
     this.validValueItems = enumValue;
     this.openContext(event, this.enumOptionsMenu, enumValue);
 }

 openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
   this.isContextOpen = true;
   this.closeContext();
   x = x + 50;
   y = y - 20;
   const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
       {
           originX: 'end',
           originY: 'bottom',
           overlayX: 'end',
           overlayY: 'top'
       }
   ]);
 
   this.overlayRef = this.overlay.create({
       positionStrategy,
       scrollStrategy: this.overlay.scrollStrategies.close()
   });
 
   this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));
 
   this.sub = fromEvent<MouseEvent>(document, 'click')
       .pipe(
           filter(event => {
               if (closeOnItemClick) {
                   this.closeContext();
               } else {
                   const clickTarget = event.target as HTMLElement;
                   return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
               }
           }), take(1)).subscribe(() => this.closeContext());
 }

 closeContext(): void {
  this.sub !== undefined && this.sub.unsubscribe();
  if (this.overlayRef) {
      this.isContextOpen = false;
      this.overlayRef.dispose();
      this.overlayRef = null;
  }
}

  getDocumentFormToothNumber() {
    /*if (this.treatmentModel) {
      return this.treatmentModel.cfgTeeth[0].cfgToothDescriptions[0].Notation;
    } else {
      return null;
    }*/
    // TODO: Rewire now that removed treatmentModel dependency
    return null;
  }

  onClassChange($event: EnumValidValueItemModel) {
    this.selectedPerforationModel = this.perforationModels.find(p => p.enumEndoPerfClassTypeID.toLowerCase() === $event.ValidValueItemId.toLowerCase());
    if (!this.selectedPerforationModel) {
      this.selectedPerforationModel = new TreatmentEndoPerforationDataModel();
      this.selectedPerforationModel.enumEndoPerfClassTypeID = $event.ValidValueItemId;
      this.selectedPerforationModel.TreatmentID = this.treatmentId;
      this.perforationModels.push(this.selectedPerforationModel);
    }
  }
}
